'use strict';

var Sugar = require('sugar-core');

require('./build/buildMathAliasesCall');

module.exports = Sugar.Number.atan;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/atan.js
// module id = 651
// module chunks = 0